// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__XrgZT","rotation":"Loader_rotation__A2kp3","animloader":"Loader_animloader__Oqc_I"};